import React from "react";
import { redirect, useLoaderData } from "react-router-dom";
import styled from "styled-components";
import { APIProvider } from "@vis.gl/react-google-maps";

// Imported actions
import {
  getAccessTypes,
  getLocationStatusTypes,
  getLocationTypes,
} from "../../../actions/charge.js";

// Imported components
import Map from "./components/Map.js";
import NavigationBar from "../../../components/nav/NavigationBar.tsx";

// Imported utils
import { isLoggedIn } from "../../../utils/user.js";

// Styled components
const Container = styled.div`
  align-items: center;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 0px;
  height: 100vh;
  justify-content: flex-start;
  padding: 80px 0px 0px 0px;
  position: relative;
`;

const MapCanvas = styled.div`
  display: flex;
  flex-grow: 1;
  overflow: hidden;
  position: relative;
  width: 100%;
`;

// Loader for router
export const loader = async () => {
  if (!isLoggedIn()) {
    return redirect("/login");
  } else {
    const accessTypes = await getAccessTypes();
    const locationStatusTypes = await getLocationStatusTypes();
    const locationTypes = await getLocationTypes();

    return {
      accessTypes,
      locationStatusTypes,
      locationTypes,
    };
  }
};

const MapPage = () => {
  const loaderData = useLoaderData();

  return (
    <Container>
      <NavigationBar />

      <MapCanvas>
        <APIProvider apiKey={"AIzaSyBy0cowEjTB0suohBM4h4UdiSz-ng-YPWg"}>
          <Map
            accessTypes={loaderData.accessTypes}
            locationStatusTypes={loaderData.locationStatusTypes}
            locationTypes={loaderData.locationTypes}
          />
        </APIProvider>
      </MapCanvas>
    </Container>
  );
};

export default MapPage;
